"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1842],{

/***/ 311842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MiddleBody1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody1/Category.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4rem 0 2rem;\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  top: 50%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CategoryContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CategoryContainer",
    componentId: "sc-6927a11-0"
})(_templateObject());
var CategoryHeading = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "CategoryHeading",
    componentId: "sc-6927a11-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var ViewMoreButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ViewMoreButton",
    componentId: "sc-6927a11-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(842783);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(368464);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody1/index.tsx











var Category = function(props) {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalogData: state.catalogReducer,
            commonData: state.commonReducer
        };
    }), categories = ref.catalogData.categories, _commonData = ref.commonData, heroBannerHeightCalculated = _commonData.heightCalculation.heroBannerHeightCalculated;
    var settings = {
        dots: false,
        // centerMode: true,
        infinite: false,
        slidesToShow: deviceWidth/* deviceWidth */.o < 766 ? 1 : 3,
        slidesToScroll: 1,
        speed: 500
    };
    // const onItemsImageClick = async (item) => {
    //   const util = await import('@/utils/routes');
    //   const { getRoute, PATH } = util;
    //   const route = getRoute(
    //     PATH.productDescription(
    //       item.id,
    //       item.name.replace(/[&\/\\#, +()$~%.'":*?<>{}\n]/g, '-')
    //     ),
    //     store_info?.domain
    //   );
    //   router.push(route);
    // };
    return (heroBannerHeightCalculated || router.route.includes("shop")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeading, {
                children: "Collections"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                    productList: categories,
                    oldCardConfigs: {
                        showButton: props.showATCBtn,
                        showCategoryCard: true
                    }
                })
            }))
        ]
    });
};
/* harmony default export */ var MiddleBody1 = (Category);


/***/ }),

/***/ 368464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(639996);



/***/ })

}]);